import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

async function patchRestoreDeletedImage(imageId: number): Promise<AxiosResponse<FetchResult<string>>> {
  const response = await instance.patch(`/images/${imageId}/restore`);
  return response;
}

const usePatchRestoreDeletedImage = (
  onSuccess?: (data: AxiosResponse<FetchResult<string>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['patch', `/images/:id/restore`],
    mutationFn: (imageId: number) => patchRestoreDeletedImage(imageId),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync, isPending };
};

export default usePatchRestoreDeletedImage;
